module.exports = __webpack_public_path__ + "img/home_logo.e7241411.png";